import { useContext } from "react";
import { AuthContext } from "../providers/AuthProvider";

const GetUser = () => {
  const auth = useContext(AuthContext);
  return auth?.user!;
};

export default GetUser;
